import { jsx as _jsx } from "react/jsx-runtime";
import Eye from '@helsenorge/designsystem-react/components/Icons/Eye';
import NoEye from '@helsenorge/designsystem-react/components/Icons/NoEye';
import FrankensteinSharingStatus from '@helsenorge/designsystem-react/components/SharingStatus';
import StatusDot from '@helsenorge/designsystem-react/components/StatusDot';
import { Projects, useResources } from '../resources';
import styles from './styles.module.scss';
const SharingStatus = ({ classNames, selectedStatusType }) => {
    const resources = useResources(Projects.FRAMEWORK);
    if (!resources) {
        return null;
    }
    let sharingStatus = null;
    switch (selectedStatusType) {
        case 'skjultForBarnet':
            sharingStatus = _jsx(StatusDot, { variant: "hidden", text: resources.sharing_Status_Skjult_For_Barnet });
            break;
        case 'skjultForFullmektig':
            sharingStatus = _jsx(StatusDot, { variant: "hidden", text: resources.sharing_Status_Skjult_For_Fullmektig });
            break;
        case 'deltMedBarnet':
            sharingStatus = (_jsx(FrankensteinSharingStatus, { icon: Eye, color: 'kiwi', className: styles['sharing-status-label'], children: resources.sharing_Status_Delt_Med_Barnet }));
            break;
        case 'bareSynligForDeg':
            sharingStatus = (_jsx(FrankensteinSharingStatus, { icon: NoEye, color: 'cherry', className: styles['sharing-status-label'], children: resources.sharing_Status_Bare_Synlig_For_Deg }));
            break;
        default:
            sharingStatus = null;
    }
    return _jsx("div", { className: classNames, children: sharingStatus });
};
export default SharingStatus;
